import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import { requiredDropdown } from 'helpers/ValidationHelpers';
import React from 'react';
import { FullField } from 'components/CustomFields/CustomFields.jsx';

const fmi = props => {
	const occupationalQuestions = [];

	if (props.occupationQuestions && props.occupationQuestions.length > 0) {
		props.occupationQuestions.map(o => {
			var parsedQs = JSON.parse(o.oq_questions);
			parsedQs.map((q, i) => {
				occupationalQuestions.push({ id: `${o.oq_Id}q${i}`, question: q });
				return q;
			});

			return o;
		});
	}

	return (
		<Grid container>
			<FullField
				name={'workOutsideBorder'}
				label={
					'Does your job require you to work outside of the borders of R.S.A? *'
				}
				component={FormDropdown}
				checkValidation={props.checkValidation}
				isrequired={true}
				validate={[requiredDropdown]}
				options={[
					{ value: 'validationError', displayValue: 'Please select' },
					{ value: 'Y', displayValue: 'Yes' },
					{ value: 'N', displayValue: 'No' }
				]}
			/>

			{occupationalQuestions.map(o => {
				const answersOptions = [
					{ value: 'validationError', displayValue: 'Please select' }
				];
				o.question.answers.map(a => {
					answersOptions.push({ value: a, displayValue: a });
					return a;
				});
				return (
					<React.Fragment key={o.id}>
						<GridItem xs={12} sm={12} md={12}>
							<Typography variant="caption">{o.question.question}</Typography>
						</GridItem>

						<FullField
							name={`occupationalQs.target10.${o.id}`}
							component={FormDropdown}
							checkValidation={props.checkValidation}
							isrequired={true}
							validate={[requiredDropdown]}
							options={answersOptions}
						/>
					</React.Fragment>
				);
			})}
		</Grid>
	);
};

export default fmi;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/CompanySpecificQuestions/fmi.jsx